import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Product } from "./product-entity";


export class ProductLinkedProduct extends BaseEntity {

  productCode             : string;
  linkedProductCode       : string;
  linkedProduct           : Product;
  type                    : number;
  rank                    : number;
   
}